@mixin background {
  border-radius: 10px;
}

.system-components-row {
  .system-components-row-block {
    padding-left: 0;
    padding-right: 0;
    padding-bottom: 15px;
    @include background;
    .label {
      white-space: normal;
      padding-bottom: 5px;
      font-size: 20px;
      font-weight: 100;
      // width: 50%;
    }

    .remove-padding {
      padding-left: 0;
      padding-right: 0;
    }

    .boolean-component {
      float: none !important;
    }

    .external-interface-dd {
      .select-checkbox-dropdown {
        .btn.select-checkbox-btn {
          max-height: 30px;
          padding: 0;
          box-shadow: 0 5px 2px -1px black;
          display: flex;
          justify-content: space-between;

          & :first-child {
            padding: 5px;
          }

          .caret {
            border-left: 1px solid black;
            width: 31px;
            padding: 5px 0;
            text-align: center;
            max-width: 31px;

            .icon-caret {
              padding: 0;
            }
          }
        }
      }
    }

    @media (min-width: 501px) and(max-width: 1000px) {
      .boolean-component {
        //  float: right !important;
      }
    }

    @media (min-width: 768px) and (max-width: 850px) {
      .tab-view {
        width: 50% !important;
      }
      .tab-view-none {
        display: none;
      }
    }
  }

  @media (max-width: 767px) {
    .system-components-row-block {
      padding-bottom: 0;
      .mobile-view {
        padding-right: 0 !important;
        padding-left: 0 !important;
      }
    }
  }
}



// WEBPACK FOOTER //
// webpack:///var/jenkins_home/workspace/azure-prod-baristadj-server/src/app/components/settings/miscellaneous/system/system.scss